import { literals } from "@/constants/literals";
import Textarea from "@/components/textarea/Textarea";
import InputCheckbox from "@/components/input-checkbox/InputCheckbox";
import InputSelect from "@/components/input-select/InputSelect";
import { CAPTURE_DESCRIPTION_OPTIONS } from "@/constants/selectsLists";
import type { GroupData, ReceptionStep } from "@/types/types.d";

type ReceptionGroupMobileInputsProps = {
  formData: GroupData;
  step: ReceptionStep;
  description: string;
  extraInformation: string;
  changeGroupData: (id: string, value: string | boolean) => void;
  changeDescription: (value: string) => void;
  changeExtraInformation: (value: string) => void;
};

const ReceptionGroupMobileInputs = ({
  step,
  formData,
  description,
  extraInformation,
  changeGroupData,
  changeDescription,
  changeExtraInformation,
}: ReceptionGroupMobileInputsProps) => {
  return (
    <div className="w-full my-4" data-testid="mobile-inputs">
      {step === literals.inNoServ ? (
        <div className="w-full mb-4">
          <InputSelect
            size="medium"
            label={literals.description}
            id="description"
            name="description"
            options={CAPTURE_DESCRIPTION_OPTIONS}
            onChange={changeDescription}
            value={description}
            required
            placeholder={literals.chooseAnOption}
          />
        </div>
      ) : null}
      {step === literals.inNoServ ? (
        <Textarea
          label={literals.extraInformation}
          onChange={changeExtraInformation}
          name="extrainformation"
          value={extraInformation}
          deleteMessage={literals.cleanExtrainfo}
          size="medium"
          required={description === "Others"}
        />
      ) : (
        <Textarea
          label={literals.description}
          onChange={(description) =>
            changeGroupData("description", description)
          }
          name="description"
          value={formData.description}
          deleteMessage={literals.cleanDescription}
          size="medium"
        />
      )}
      <InputCheckbox
        title={literals.visibleForClients}
        onChange={(new_value) => changeGroupData("visibleForClient", new_value)}
        checked={formData.visibleForClient}
        id="visibleForClient"
      />
    </div>
  );
};

export default ReceptionGroupMobileInputs;
